import {Helmet} from "react-helmet";
import {Box, Button, Container, Divider, Grid, Typography} from "@mui/material";
import * as PropTypes from "prop-types";
import {BrowserUpdatedRounded} from "@mui/icons-material";


function Item(props) {
    return null;
}

export default function Landing() {

    return (
        <>
            <Helmet>
                <title>درایو میلفا</title>
                </Helmet>
            <Container sx={{ mt: 3, mb: 7 }}>
                <Grid container spacing={1} xs={10} margin={'auto'}>
                    <Grid item xs={8} margin={'auto'}>
                        <Typography mt={1} textAlign="justify">میخوایی فایلهای مهمت رو یک جای امن ذخیره کنی ؟</Typography>
                        <Typography mt={1} textAlign="justify">میخوایی از هر جایی و با هر سیستمی به فایلهات دسترسی داشته باشی ؟</Typography>
                        <Typography mt={1} textAlign="justify">کسی میخواد برات فایل بفرسته ولی نمیتونه ؟</Typography>
                        <Typography mt={1} textAlign="justify">میخوایی برای چند نفر یک فایل رو بفرستی ولی نمیشه ؟</Typography>
                        <Typography mt={1} textAlign="justify">فایلهایی که فرستادی و دریافت کردی گم میشن و پاک میشن ؟</Typography>
                        <Typography mt={1} textAlign="justify">میخوایی از پیامکها و لیست تماسها و دفترچه آدرس گوشی بکاپ بگیری ؟</Typography>
                    </Grid>
                    <Grid item xs={4} margin={'auto'}>
                        <Box component="img" alt="Icon" src={"/assets/image/picture/paper_2.svg"} width={1} sx={{ objectFit: "contain" }}/>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={8} margin={'auto'} textAlign={'center'}>
                        <Typography fontSize={{ xs: "1.25rem", lg: "1.35rem" }} fontWeight={800}>ما برای همه اینها راه حل داریم</Typography>
                        <Typography fontSize={{ xs: "1.15rem", lg: "1.25rem" }} fontWeight={600}>درایو میلفا یک سیستم جامع ذخیره و اشتراک فایل ابری هست</Typography>
                        <Typography fontSize={{ xs: "1.05rem", lg: "1.15rem" }} fontWeight={400}>یه کار جالب دیگه که با درایو میلفا میشه انجام بدی :</Typography>
                    </Grid>
                    <Grid item xs={8} margin={'auto'} textAlign={'center'}>
                        <Typography mt={1} textAlign="justify">اگه مشتری یا افرادی هستن که باید مدام براشون فایل بفرستی کافیه از امکان اشتراک گذاری فولدر یا شاخه درایو میلفا استفاده کنی</Typography>
                        <Typography mt={1} textAlign="justify">با این امکان یک شاخه یا فولدر میسازی و اون رو برای فرد یا افراد مورد نظرت اشتراک گذاری میکنی از این به بعد هر فایلی داخل این شاخه بزاری همه کسایی که این شاخه براشون اشتراک گذاری شده فایلها رو میتونن ببینن و نیازی نیست هر دفعه براشون اشتراک گذاری جدید ایجاد کنی</Typography>
                        <Typography mt={1} textAlign="justify">میخوایی یک سری فایل رو از گوشی به کامپیوترت انتقال بدی خیلی راحت هم با یک مرورگر معمولی و یا با نصب اپلیکیشن موبایل درایو میلفا روی گوشی میتونی فایلها رو اونجا اپلود کنی بعد روی کامپیوتر با مرورگر ساده به حسابت وارد بشی و همه فایلها رو ببینی</Typography>



                        <Grid container spacing={1} xs={12} margin={'auto'}>
                            <Grid item xs={12} margin={'auto'}>
                                <Typography my={3} fontSize={{ xs: "1.15rem", lg: "1.25rem" }} fontWeight={600} textAlign="justify">برای دانلود نسخه اندروید درایو میلفا اینجا کلیک کن</Typography>
                            </Grid>
                            <Grid item xs={12} margin={'auto'}>
                                <Grid mt={1} container spacing={2}>
                                    <Grid item xs={12} container >
                                        <Grid item xs={12} lg={3}>
                                            <a href="#" target="_blank">
                                                <Box component="img" src="/assets/image/logo/mobile-coffe-bazzar.svg" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                            </a>
                                        </Grid>
                                        <Grid item xs={12} lg={3}>
                                            <a href="#" target="_blank">
                                                <Box component="img" src="/assets/image/logo/myket-dark.svg" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                            </a>
                                        </Grid>
                                        <Grid item xs={12} lg={3}>
                                            <a href="/static/apps/mailfa-drive.apk" target="_blank">
                                                <Button variant="contained" fullWidth startIcon={<BrowserUpdatedRounded/>} disableElevation sx={{ borderRadius: 2, py: 1.7 }}>دانلود مستقیم</Button>
                                            </a>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Typography my={3} textAlign="justify">ما یک پلن وِیژه به مناسبت افتتاح این سیستم تعریف کردیم که خیلی قیمت خوبی داره پیشنهاد میکنیم همین الان این سرویس رو تهیه کنی؟</Typography>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}
